import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './en.json';
import azTranslations from './az.json';
import ruTranslations from './ru.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      az: { translation: azTranslations },
      ru: { translation: ruTranslations },
    },
    lng: localStorage.getItem('i18nextLng'),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
